import { DefaultCellRenderer } from '@dealstack/frontend/shared/components/Table/Table/Table';
import { CellRendererProps, TData } from '@dealstack/frontend/shared/components/Table/Table/types';
import { ReactNode } from 'react';

export const CellRenderer = <T extends TData>(props: CellRendererProps<T>): JSX.Element => {
	if (props.column.id.endsWith('-cost') || props.column.id.endsWith('-amount')) {
		const { cellValueFn, ...rest } = props;
		return (
			<div {...rest} className="pl-4 mr-4 w-full flex justify-end">
				{cellValueFn(rest.column, rest.item) as ReactNode}
			</div>
		);
	} else if (props.column.id.startsWith('securities-') && props.column.id.endsWith('-number')) {
		return <DefaultCellRenderer {...props} className="pl-4 mr-4 w-full flex justify-end" />;
	} else {
		return <DefaultCellRenderer {...props} className="pl-4 mr-4" />;
	}
};
